<section class="page-section" id='profile'>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
            <div class="profile-image">
                <img src="assets/img/default/user.svg" />
            </div>
          <h2 class="section-heading text-uppercase">{{us.user.name +"  "+us.user.surname}}</h2>
          <h3 class="section-subheading text-fsp"><i class="fa fa-envelope mr-3"></i>{{us.user.email}}
            <br/><i class="fa fa-phone mr-3"></i>{{us.user.phone}}</h3>
            <a routerLink="edit" class="btn btn-fsp mx-1">Edit profile</a>
            <a routerLink="/resume" class="btn btn-fsp mx-1">My Resume</a>
        </div>
      </div>
    </div>
  </div>
</section>
